import { Box, Text, Button, Image } from '@domain-group/suit-theme'

import { faPage } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import blankImageUrl from '../assets/no-template-page.svg'

type CanvaTemplatePageBlankStateProps = {
  integrated: boolean,
  loading: boolean,
  syncBrandTemplates: () => void,
}

const CanvaTemplatePageBlankState = (props: CanvaTemplatePageBlankStateProps) => {
  const { integrated, loading, syncBrandTemplates } = props

  return (
    <Box
      backgroundColor="white"
      border="1px solid"
      borderColor="lineColor"
      borderRadius={5}
      flexDirection="row"
      padding="large"
      marginBottom={0}
    >
      <Box
        flexDirection="column"
        justifyContent="center"
        width="100%"
        textAlign="center"
      >
        {blankImageUrl && (
          <Box
            alignItems="center"
            justifyContent="center"
            marginLeft="auto"
            paddingY="medium"
            width="100%"
          >
            <img alt="Blank State" src={blankImageUrl} style={{ maxWidth: '100%' }} />
          </Box>
        )}

        <Text fontSize="medium" fontWeight={300}>
          No Templates
        </Text>

        <Text color="bodyFontLightColor" fontSize="small" lineHeight="1.3" marginTop="large">
          There are no templates to display. You need to first connect to Canva to start linking new templates.
        </Text>

        <Box marginTop="large" marginX="auto" justifyContent="center">
          <Button
            buttonStyle="primaryEdit"
            disabled={!integrated}
            loading={loading}
            size="medium"
            icon={<FontAwesomeIcon icon={faPage} />}
            style={{ width: 'auto' }}
            onClick={syncBrandTemplates}
          >
            Link New Templates
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default CanvaTemplatePageBlankState
